import React, { useState, useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ReplayIcon from '@material-ui/icons/Replay'

import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Slider from '@material-ui/core/Slider'
import './saaviSlider.css'

const useStyles = makeStyles(() => ({
  btn: {
    boxShadow: 'none',
    color: '#a65e44',
    borderColor: '#a65e44',
    '&:hover': {
      backgroundColor: '#a65e441A',
      borderColor: '#a65e44',
      boxShadow: 'none',
    },
  },
}))
export function SeasonSlider(props) {
  const classes = useStyles()

  return (
    <div>
      <div style={{ display: 'flex', flexFlow: 'column' }}>
        <label className="units-saavi-tag">{props.title}</label>
        <div style={{ width: '100%', display: 'flex' }}>
          <label className="heatmap-tags-saavi-left">
            {props.sliderValue[0]} {props.units}
          </label>
          <div className="color-bar-saavi" />
          <label className="heatmap-tags-saavi-right">
            {props.sliderValue[1]} {props.units}
          </label>
        </div>
        <div className="color-legend-saavi" style={{ marginLeft: '0px', width: '100%' }}>
          <label style={{ fontSize: '12px', margin: 'auto', marginLeft: '15px' }}>
            {props.sliderValue[0]} {props.units}
          </label>
          <label style={{ fontSize: '12px', margin: 'auto', marginRight: '15px' }}>
            {props.sliderValue[1]} {props.units}
          </label>
        </div>
      </div>
      <label className="heatmap-value-tag-saavi">Heatmap Value</label>
      <Slider
        value={props.sliderValue}
        className={props.classes.root}
        onChange={props.slider}
        onChangeCommitted={props.onChangeAfter}
        step={props.step}
        min={props.min}
        max={props.max}
        valueLabelDisplay="auto"
        aria-labelledby="range-slider"
        style={{ marginTop: '5px' }}
      />
      <div style={{ display: 'flex' }}>
        <Button
          style={{ margin: 'auto', height: '25px' }}
          size="small"
          variant="outlined"
          className={classes.btn}
          endIcon={<ReplayIcon />}
          onClick={() => {
            props.setSliderValue([props.reset[0], props.reset[1]])
            props.heatmap(props.reset[0], props.reset[1], props.layers)
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  )
}

SeasonSlider.defaultProps = {
  step: 1,
  min: 0,
  max: 3000,
  reset: [0, 1000],
  title: 'Available Capacity',
  units: ['MW', 'MW+'],
}
